import type { ReactNode } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useApp } from "@/hooks/use-app-context";
import { canReturnTo, homePathForRole } from "@/lib/auth/roles";

/**
 * Sends a signed-in profile back to its own space when the page is not
 * theirs: each back-office role only has its panel (plus the public site),
 * an admin does not open the accountant space, a contributor no panel.
 * Visitors pass through; pages that need sign-in check it themselves.
 */
export function OwnSpaceOnly({ children }: { children: ReactNode }) {
  const { user, isAuthenticated } = useApp();
  const { lang = "fr" } = useParams<{ lang: string }>();
  const { pathname, search } = useLocation();
  if (isAuthenticated && user && !canReturnTo(`${pathname}${search}`, user.role, lang)) {
    return <Navigate to={homePathForRole(user.role, lang)} replace />;
  }
  return <>{children}</>;
}
